export const SET_IS_LOADING = "SET_IS_LOADING/settings-page";
export const SET_SETTINGS_DATA = "SET_SETTINGS_DATA/settings-page";
export const SET_ORDER_DETAIL = "SET_ORDER_DETAIL/settings-page";
